import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logos/Sync_app.png'


const _withScopeId = n => (_pushScopeId("data-v-fde62834"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "doc-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", null, "Tree Crossing Sync"),
  /*#__PURE__*/_createElementVNode("div", { class: "tagline" }, " Easily upload your family tree with all your photos and documents. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "What is the Sync app?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The Sync app helps you upload your family tree directly from your computer, then keep your online tree up-to-date as you continue working on it. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The app has special features for managing privacy and uploading photos and documents that make it a better option than GEDCOM or uploading your database file directly. It's easy to install and use, and it only takes a minute or two to sync. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Will it modify any files on my computer?", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The Sync app only reads your genealogy files. No changes are "),
  /*#__PURE__*/_createElementVNode("b", null, "ever"),
  /*#__PURE__*/_createTextVNode(" made to any files on your computer. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "app-support" }, "What genealogy programs does the Sync app support?", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "What gets synced?", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Data types", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The Sync app will upload the following data from your tree: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "People"),
    /*#__PURE__*/_createElementVNode("li", null, "Families"),
    /*#__PURE__*/_createElementVNode("li", null, "Events/Facts"),
    /*#__PURE__*/_createElementVNode("li", null, "Places"),
    /*#__PURE__*/_createElementVNode("li", null, "Addresses/Sites"),
    /*#__PURE__*/_createElementVNode("li", null, "Photos and documents")
  ])
], -1))
const _hoisted_13 = { class: "inline-question" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-inline btn-link",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#otherDataTypes"
}, "Will my online tree include sources?", -1))
const _hoisted_15 = {
  id: "otherDataTypes",
  class: "collapse"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<h4 id=\"privacy\" data-v-fde62834>What about privacy?</h4><h5 data-v-fde62834>Living people</h5><p data-v-fde62834> We try to provide a great experience for everyone in your family, while keeping the right people in control of their own data. </p><p data-v-fde62834> Here&#39;s what the Sync app does, before it uploads any data from your tree: <ul data-v-fde62834><li data-v-fde62834>The app identifies &quot;living or recently living&quot; people.</li><li data-v-fde62834>It blocks upload of any details about living people in this group, except their <b data-v-fde62834>name</b>, <b data-v-fde62834>gender</b>, and <b data-v-fde62834>relationships</b>.</li><li data-v-fde62834>It gives you the option to omit specific people completely.</li></ul></p><p data-v-fde62834> Here&#39;s what happens with living or recently living people once your tree has been uploaded: <ul data-v-fde62834><li data-v-fde62834>Separate profiles are created for them that can be managed by individual owners.</li><li data-v-fde62834>When you invite someone to join a group and start exploring your tree, you include their profile in the invitation.</li><li data-v-fde62834>When they accept, they become the owner of that profile.</li></ul> As the profile owner, they can then decide what (if any) information they want to continue sharing, and with whom. If they add more information to their profile, it won&#39;t be synced back to your computer. </p><p data-v-fde62834> The Sync app treats a person in your tree as &quot;living or recently living&quot; if: <ul data-v-fde62834><li data-v-fde62834>No death (or similar event, e.g. burial or cremation) is recorded, <b data-v-fde62834>AND</b></li><li data-v-fde62834>The date of their birth (or similar event, e.g. christening) was less than 110 years ago, <b data-v-fde62834>OR</b></li><li data-v-fde62834>No birth event is recorded, and their estimated* birth year is less than 110 years ago</li></ul></p>", 6)
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "* The Sync app estimates birth years based on birth and death dates of the person's closest relatives.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Ancestors", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Data about everyone else in your tree, and shared data such as places that are associated with both living and deceased people, are uploaded as-is, unless you've specifically marked them as \"private\" in your tree. ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Who can see my tree?", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " When you upload your tree, it is only visible to you by default. You can choose to share it with others by creating a group, sharing your tree with the group, and inviting others to join the group. ", -1))

import AppSupportGrid from '@/public/AppSupportGrid.vue';
import router from '@/router';
import SyncDiagram from '@/sync/SyncDiagram.vue';
import { usePageTitle } from '@/util/AppUtil'
import { PlatformUtil } from '@/util/PlatformUtil'
import { AlertTriangleIcon } from '@zhuowenli/vue-feather-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncOverviewPage',
  setup(__props) {

const title = usePageTitle('How does the Sync app work?')

const isWindows = PlatformUtil.isWindows()


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_P = _resolveComponent("P")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_unref(title)), 1),
    _createVNode(_component_router_link, {
      to: "/syncapp",
      class: "link-dark syncapp-tile"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _createElementVNode("p", null, [
      _createTextVNode(" Here's the current list, and we're considering more! "),
      _createVNode(_component_router_link, { to: "/support" }, {
        default: _withCtx(() => [
          _createTextVNode("Send feedback")
        ]),
        _: 1
      }),
      _createTextVNode(" if you'd like us to add yours. ")
    ]),
    _createVNode(AppSupportGrid),
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createTextVNode(" We're working on it! "),
        _createVNode(_component_router_link, { to: "/support" }, {
          default: _withCtx(() => [
            _createTextVNode("Let us know")
          ]),
          _: 1
        }),
        _createTextVNode(" if you'd like to see other data included as well. ")
      ])
    ]),
    _hoisted_16,
    _createVNode(_component_P, null, {
      default: _withCtx(() => [
        _hoisted_22
      ]),
      _: 1
    }),
    _hoisted_23,
    _hoisted_24,
    _createElementVNode("p", null, [
      _createVNode(_component_router_link, { to: "/privacy" }, {
        default: _withCtx(() => [
          _createTextVNode("Learn more about privacy")
        ]),
        _: 1
      })
    ]),
    _hoisted_25,
    _hoisted_26
  ]))
}
}

})